// Colors are kept in-app rather than added to core since this is an experiment
// and we're not sure if this feature will live. We want to roll out fast.
export const GUARANTEED_PAY_BANNER_GRADIENT = "linear-gradient(to bottom, #F1EBAB, #FFDCA4)";
export const GUARANTEED_PAY_BOTTOM_SHEET_GRADIENT = "linear-gradient(to bottom, #FFFDEF, #FFEDCF)";

export const GUARANTEED_PAY_PRICING_SURVEY_STORAGE_KEY_PREFIX =
  "guaranteed-pay-pricing-survey-response";

export const GUARANTEED_PAY_PRICING_RESPONSES = {
  DISMISSED: "DISMISSED",
  PRICE_1_00: "PRICE_1_00",
  PRICE_2_00: "PRICE_2_00",
  PRICE_3_00: "PRICE_3_00",
  NOT_INTERESTED: "NOT_INTERESTED",
} as const;

export type GuaranteedPayPricingResponse =
  (typeof GUARANTEED_PAY_PRICING_RESPONSES)[keyof typeof GUARANTEED_PAY_PRICING_RESPONSES];

export type GuaranteedPaySurveyOption = Exclude<
  GuaranteedPayPricingResponse,
  typeof GUARANTEED_PAY_PRICING_RESPONSES.DISMISSED
>;

export const GUARANTEED_PAY_SURVEY_OPTIONS: GuaranteedPaySurveyOption[] = [
  GUARANTEED_PAY_PRICING_RESPONSES.PRICE_1_00,
  GUARANTEED_PAY_PRICING_RESPONSES.PRICE_2_00,
  GUARANTEED_PAY_PRICING_RESPONSES.PRICE_3_00,
  GUARANTEED_PAY_PRICING_RESPONSES.NOT_INTERESTED,
];

export const GUARANTEED_PAY_PRICING_RESPONSE_LABELS: Record<GuaranteedPaySurveyOption, string> = {
  [GUARANTEED_PAY_PRICING_RESPONSES.PRICE_1_00]: "$1.00/hour",
  [GUARANTEED_PAY_PRICING_RESPONSES.PRICE_2_00]: "$2.00/hour",
  [GUARANTEED_PAY_PRICING_RESPONSES.PRICE_3_00]: "$3.00/hour",
  [GUARANTEED_PAY_PRICING_RESPONSES.NOT_INTERESTED]: "I'm not interested in this feature",
};

export function getGuaranteedPayPricingSurveyStorageKey(workerId: string): string {
  return `${GUARANTEED_PAY_PRICING_SURVEY_STORAGE_KEY_PREFIX}-${workerId}`;
}
